<c-flexible-list-item-editor-item view="$ctrl.view"></c-flexible-list-item-editor-item>